// Indian state → land-unit conversion table.
// Every entry is normalised into sq ft so downstream area / price / land-fill
// calculators just multiply. All numbers are the widely-used revenue values;
// where local variance exists we pick the state-standard.

export const STATE_UNITS = {
  // ---------- East India ----------
  'West Bengal':      { primary: 'katha',  units: [
    { key: 'katha',   label: 'Katha',   sqft: 720 },
    { key: 'bigha',   label: 'Bigha',   sqft: 14400 },   // 20 katha
    { key: 'chatak',  label: 'Chatak',  sqft: 45 },
    { key: 'decimal', label: 'Decimal', sqft: 435.6 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Bihar':            { primary: 'dhur', units: [
    { key: 'dhur',    label: 'Dhur',    sqft: 68.0625 },
    { key: 'katha',   label: 'Katha',   sqft: 1361.25 },  // 20 dhur
    { key: 'bigha',   label: 'Bigha',   sqft: 27225 },    // 20 katha
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Jharkhand':        { primary: 'katha', units: [
    { key: 'katha',   label: 'Katha',   sqft: 1361.25 },
    { key: 'bigha',   label: 'Bigha',   sqft: 27225 },
    { key: 'decimal', label: 'Decimal', sqft: 435.6 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Odisha':           { primary: 'decimal', units: [
    { key: 'decimal', label: 'Decimal', sqft: 435.6 },
    { key: 'guntha',  label: 'Guntha',  sqft: 1089 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'gaj',     label: 'Gaj',     sqft: 9 },
  ]},
  'Assam':            { primary: 'katha', units: [
    { key: 'lessa',   label: 'Lessa',   sqft: 144 },
    { key: 'katha',   label: 'Katha',   sqft: 2880 },
    { key: 'bigha',   label: 'Bigha',   sqft: 14400 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Tripura':          { primary: 'kani', units: [
    { key: 'gonda',   label: 'Gonda',   sqft: 288 },
    { key: 'kani',    label: 'Kani',    sqft: 5760 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Meghalaya':        { primary: 'katha', units: [
    { key: 'katha',   label: 'Katha',   sqft: 2880 },
    { key: 'bigha',   label: 'Bigha',   sqft: 14400 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Sikkim':           { primary: 'acre', units: [
    { key: 'gaj',     label: 'Gaj',     sqft: 9 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'hectare', label: 'Hectare', sqft: 107639 },
  ]},

  // ---------- North India ----------
  'Uttar Pradesh':    { primary: 'bigha', units: [
    { key: 'biswa',   label: 'Biswa',   sqft: 1361.25 },
    { key: 'bigha',   label: 'Bigha',   sqft: 27225 },   // 20 biswa (pucca)
    { key: 'kachha',  label: 'Kachha Bigha', sqft: 9070 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'gaj',     label: 'Gaj',     sqft: 9 },
  ]},
  'Uttarakhand':      { primary: 'nali', units: [
    { key: 'nali',    label: 'Nali',    sqft: 2160 },
    { key: 'muthi',   label: 'Muthi',   sqft: 108 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'bigha',   label: 'Bigha',   sqft: 6804 },
  ]},
  'Delhi':            { primary: 'gaj', units: [
    { key: 'gaj',     label: 'Gaj',     sqft: 9 },
    { key: 'sqyd',    label: 'Sq. Yard', sqft: 9 },
    { key: 'sqft',    label: 'Sq. Ft.', sqft: 1 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Haryana':          { primary: 'kanal', units: [
    { key: 'marla',   label: 'Marla',   sqft: 272.25 },
    { key: 'kanal',   label: 'Kanal',   sqft: 5445 },     // 20 marla
    { key: 'killa',   label: 'Killa',   sqft: 43560 },    // = acre
    { key: 'gaj',     label: 'Gaj',     sqft: 9 },
  ]},
  'Punjab':           { primary: 'kanal', units: [
    { key: 'marla',   label: 'Marla',   sqft: 272.25 },
    { key: 'kanal',   label: 'Kanal',   sqft: 5445 },
    { key: 'killa',   label: 'Killa',   sqft: 43560 },
    { key: 'ghumaon', label: 'Ghumaon', sqft: 43560 },
  ]},
  'Himachal Pradesh': { primary: 'bigha', units: [
    { key: 'bigha',   label: 'Bigha',   sqft: 8712 },     // = 1/5 acre
    { key: 'biswa',   label: 'Biswa',   sqft: 435.6 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Jammu & Kashmir':  { primary: 'kanal', units: [
    { key: 'marla',   label: 'Marla',   sqft: 272.25 },
    { key: 'kanal',   label: 'Kanal',   sqft: 5445 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Ladakh':           { primary: 'kanal', units: [
    { key: 'kanal',   label: 'Kanal',   sqft: 5445 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},

  // ---------- West India ----------
  'Rajasthan':        { primary: 'bigha', units: [
    { key: 'bigha',   label: 'Bigha',   sqft: 27225 },    // pucca
    { key: 'kachha',  label: 'Kachha Bigha', sqft: 17424 },
    { key: 'biswa',   label: 'Biswa',   sqft: 1361.25 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Gujarat':          { primary: 'vigha', units: [
    { key: 'guntha',  label: 'Guntha',  sqft: 1089 },
    { key: 'vigha',   label: 'Vigha',   sqft: 17424 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'sqmt',    label: 'Sq. Metre', sqft: 10.764 },
  ]},
  'Maharashtra':      { primary: 'guntha', units: [
    { key: 'guntha',  label: 'Guntha',  sqft: 1089 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'hectare', label: 'Hectare', sqft: 107639 },
    { key: 'sqmt',    label: 'Sq. Metre', sqft: 10.764 },
  ]},
  'Goa':              { primary: 'sqmt', units: [
    { key: 'sqmt',    label: 'Sq. Metre', sqft: 10.764 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'hectare', label: 'Hectare', sqft: 107639 },
  ]},
  'Madhya Pradesh':   { primary: 'bigha', units: [
    { key: 'bigha',   label: 'Bigha',   sqft: 12000 },
    { key: 'biswa',   label: 'Biswa',   sqft: 600 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Chhattisgarh':     { primary: 'decimal', units: [
    { key: 'decimal', label: 'Decimal', sqft: 435.6 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'hectare', label: 'Hectare', sqft: 107639 },
  ]},

  // ---------- South India ----------
  'Karnataka':        { primary: 'guntha', units: [
    { key: 'guntha',  label: 'Guntha',  sqft: 1089 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'cent',    label: 'Cent',    sqft: 435.6 },
    { key: 'sqmt',    label: 'Sq. Metre', sqft: 10.764 },
  ]},
  'Andhra Pradesh':   { primary: 'ground', units: [
    { key: 'ground',  label: 'Ground',  sqft: 2400 },
    { key: 'cent',    label: 'Cent',    sqft: 435.6 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'guntha',  label: 'Guntha',  sqft: 1089 },
  ]},
  'Telangana':        { primary: 'ground', units: [
    { key: 'ground',  label: 'Ground',  sqft: 2400 },
    { key: 'guntha',  label: 'Guntha',  sqft: 1089 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'sqyd',    label: 'Sq. Yard', sqft: 9 },
  ]},
  'Tamil Nadu':       { primary: 'ground', units: [
    { key: 'cent',    label: 'Cent',    sqft: 435.6 },
    { key: 'ground',  label: 'Ground',  sqft: 2400 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'ma',      label: 'Ma',      sqft: 100 },
  ]},
  'Kerala':           { primary: 'cent', units: [
    { key: 'cent',    label: 'Cent',    sqft: 435.6 },
    { key: 'ares',    label: 'Ares',    sqft: 1076.4 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'hectare', label: 'Hectare', sqft: 107639 },
  ]},
  'Puducherry':       { primary: 'cent', units: [
    { key: 'cent',    label: 'Cent',    sqft: 435.6 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'ground',  label: 'Ground',  sqft: 2400 },
  ]},

  // ---------- North-East ----------
  'Arunachal Pradesh': { primary: 'acre', units: [
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'hectare', label: 'Hectare', sqft: 107639 },
  ]},
  'Nagaland':         { primary: 'acre', units: [
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'hectare', label: 'Hectare', sqft: 107639 },
  ]},
  'Manipur':          { primary: 'sangam', units: [
    { key: 'sangam',  label: 'Sangam',  sqft: 12100 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Mizoram':          { primary: 'acre', units: [
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'hectare', label: 'Hectare', sqft: 107639 },
  ]},

  // ---------- Union territories & islands ----------
  'Chandigarh':       { primary: 'marla', units: [
    { key: 'marla',   label: 'Marla',   sqft: 272.25 },
    { key: 'kanal',   label: 'Kanal',   sqft: 5445 },
  ]},
  'Andaman & Nicobar':{ primary: 'acre', units: [
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
    { key: 'hectare', label: 'Hectare', sqft: 107639 },
  ]},
  'Lakshadweep':      { primary: 'sqmt', units: [
    { key: 'sqmt',    label: 'Sq. Metre', sqft: 10.764 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
  'Dadra & Nagar Haveli and Daman & Diu': { primary: 'sqmt', units: [
    { key: 'sqmt',    label: 'Sq. Metre', sqft: 10.764 },
    { key: 'guntha',  label: 'Guntha',  sqft: 1089 },
    { key: 'acre',    label: 'Acre',    sqft: 43560 },
  ]},
};

export const ALL_STATES = Object.keys(STATE_UNITS).sort();

export const unitsForState = (state) =>
  (STATE_UNITS[state]?.units) || [
    { key: 'sqft',   label: 'Sq. Ft.',   sqft: 1 },
    { key: 'acre',   label: 'Acre',     sqft: 43560 },
  ];

export const primaryUnitOf = (state) =>
  STATE_UNITS[state]?.primary || 'sqft';

export const toSqft = (state, unitKey, value) => {
  const found = unitsForState(state).find((u) => u.key === unitKey);
  return (found?.sqft || 1) * Number(value || 0);
};

export const fromSqft = (state, unitKey, sqft) => {
  const found = unitsForState(state).find((u) => u.key === unitKey);
  return Number(sqft || 0) / (found?.sqft || 1);
};
